"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBandCodeText = exports.findPerformanceBandColor = exports.findPerformanceBand = void 0;
var __1 = require("..");
/**
 * Returns the performance band for the provided value
 * @param {string}            value      - value to match against the performance bands
 * @param {PerformanceBand[]} bands      - performance bands
 *
 * @return the performance band for the provided value
 */
var findPerformanceBand = function (value, bands) { return bands.find(function (band) { return band.inRange(value); }); };
exports.findPerformanceBand = findPerformanceBand;
/**
 * Returns the performance band color for the provided band in a curriculum
 * @param {any}         theme           - theme
 * @param {string}      curriculum      - curriculum id
 * @param {band}        band            - band
 *
 * @return the performance band color
 */
var findPerformanceBandColor = function (theme, curriculum, band) {
    return theme.Colors.Curriculum[curriculum][band];
};
exports.findPerformanceBandColor = findPerformanceBandColor;
var getBandCodeText = function (code) { return __1.BandCode[code]; };
exports.getBandCodeText = getBandCodeText;
